import { Play } from 'lucide-react';
import css from './VideoPlaceholder.module.css';

const VideoPlaceholder = () => {
  return (
    <div className={css.container}>
      {/* Gradient placeholder background */}
      <div className={css.gradientBg} />

      {/* Play button */}
      <div className={css.centerOverlay}>
        <div className={css.playButton}>
          <Play className={css.playIcon} fill="currentColor" />
        </div>
      </div>
    </div>
  );
};

export default VideoPlaceholder;
